import React from "react";

export default function ShingleList() {
  return (
    <div>
      <iframe
        height="1000px"
        name="lifetime-shingles"
        title="View All Singles"
        src="https://www.gaf.com/en-us/roofing-products/residential-roofing-products/shingles?Action=GetGrid&amp;ZipCode=89031&amp;cbviewer=none"
        style={{ border: "none" }}
        width="100%"
      ></iframe>
    </div>
  );
}

